var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('device-setups',{attrs:{"id":"device-setups","show-device-name":true,"entity":{ model: 'customers', id: _vm.customerId }}})}
var staticRenderFns = []

export { render, staticRenderFns }